import AgendamentoInterceptor from '@finx/web-repository/src/apis/Agendamento/AgendamentoInterceptor'
import FactoryResponse from '@/factories/FactoryResponse'
import { Pendencia,
  PendenciaMensagem,
  EmailMensagemQuery,
  TipoDocumentoUpload,
  Anestesista,
  CotacaoOperadorasExtraGrupo,
  SolicitacaoAcoesBackofficeEnum,
  CadastroMedicoBackoffice,
  Equipamento,
  NovoFornecedor,
  OPME,
  Procedimento,
  Hemocomponente,
  SolicitacaoComentario,
  AlteracaoDataMensagem,
  BodyRequest,
  StatusCirurgiaEnum } from '@/types/_'
import { toHttpParams } from '@/utils/common'
import { IDocumentoObrigatorio } from '@/types/interfaces/documentacao-obrigatoria/documento-obrigatorio.interface'
import { ComorbidadePayloadProps } from '@/types/interfaces/Comorbidades'
import { IniciaApa } from '@/types/interfaces/IniciaApa'

const factory = new FactoryResponse()
const api = new AgendamentoInterceptor()

/**
 * Faltou:
 *  - AgendamentoRecebeEmail
 *  - AssociarContaMedicoAssistenteFromConvite
 *  - BackofficeAgendamentoConfirmaCancelamento
 *  - BackofficeAgendamentoFazCancelamento
 *  - CriaPaciente
 *  - GetPacienteByNome
 *  - CriarMedico
 *  - EnviaEmail
 *  - EnviaEmailBoasVindasAgendamento
 */

export default {
  async abrirContestacao(solicitacaoId: string, data: any) {
    const request = await api.post(`/solicitacoes/${solicitacaoId}/contestacoes/abrir`, data)
    return factory.build(request)
  },

  async aceitarContestacao(solicitacaoId: string) {
    const request = await api.post(`/solicitacoes/${solicitacaoId}/contestacoes/aceitar`, {})
    return factory.build(request)
  },

  async abrirMensagem(solicitacaoId: string, pendenciaMensagem: PendenciaMensagem[]) {
    const url = window.location.href.toString().split('/')
    let area = ''

    switch (url[url.length - 1]) {
      case 'pre-anestesico':
        area = 'PreAnestesia'
        break
      case 'agencia-transfusional':
        area = 'AgenciaTransfusional'
        break
      default:
        area = url[url.length - 1].trim().length === 0 ? 'Agendamento' : url[url.length - 1]
    }

    const request = await api.post(`solicitacoes/${solicitacaoId}/pendencias/${area}/abrir`, pendenciaMensagem)
    return factory.build(request)
  },

  async adicionarEmail(params: any) {
    const response = await api.put(`agendamento/medico/${params.medicoId}/local-atendimento/${params.localAtendimentoId}/email-notificacao`, params)
    return factory.build(response)
  },

  async getAllLocalAtendimentoByMedico(medicoId: string) {
    const request = await api.get(`medico/${medicoId}/local-atendimento`)
    return factory.build(request)
  },

  async getEmailsRecebidos(param: EmailMensagemQuery) {
    const { area, pagina, qtdPorPagina } = param
    const query: string = `area=${area}&pagina=${pagina || 1}&qtdPorPagina=${qtdPorPagina || 25}`
    const request = await api.get(`agendamento/email-recebido?${query}`)
    return factory.build(request)
  },

  async backofficeResolveEmail(emailRecebidoId: string) {
    const request = await api.put(`agendamento/email-recebido/${emailRecebidoId}/resolve-mensagem`, '')
    return factory.build(request)
  },

  async areaMapaCirurgicoConfirmaSolicitacao({ solicitacaoId, areaMapaCirurgico, payload }: any) {
    const response = await api.put(`mapa-cirurgico/solicitacoes/${solicitacaoId}/area/${areaMapaCirurgico}/confirma`, payload)
    return factory.build(response)
  },

  async associarConta(params: any) {
    const request = await api.postAllowAnonymous(`agendamento/medicos/convite/${params.conviteId}/assistentes/${params.cpf}/local-atendimento/${params.localAtendimentoNome}`, params)
    return factory.build(request)
  },

  async associarContaSecretaria(params: any) {
    const request = await api.post(`agendamento/medicos/${params.medicoId}/assistentes/${params.cpf}/local-atendimento/${params.localAtendimentoId}`, params)
    return factory.build(request)
  },

  async cirurgiaRealizada(params: { solicitacaoId: string, statusCirurgia: StatusCirurgiaEnum }) {
    const request = await api.put(`solicitacoes/${params.solicitacaoId}/atualiza-status-cirurgia/${params.statusCirurgia}`, {})
    return factory.build(request)
  },

  async atualizarTriagem(solicitacaoId: string) {
    const request = await api.put(`solicitacoes-backoffice/${solicitacaoId}/agendamento/atualiza-triagem`, '')
    return factory.build(request)
  },

  async backofficeAgendamentoRealizaTriagem(solicitacaoId: string) {
    const request = await api.put(`solicitacoes-backoffice/${solicitacaoId}/agendamento/realiza-triagem`, '')
    return factory.build(request)
  },

  async anestesistaFazAvaliacao(anestesista: Anestesista) {
    const { solicitacaoId } = anestesista
    const request = await api.put(`solicitacoes-backoffice/${solicitacaoId}/anestesista/avalia`, anestesista)
    return factory.build(request)
  },

  async autorizacaoAlteraCotacaoExtraGrupo(solicitacaoId: string, data: { cotacaoOperadorasExtraGrupo: CotacaoOperadorasExtraGrupo | null }) {
    const request = await api.put(`solicitacoes-backoffice/${solicitacaoId}/autorizacao/altera-cotacao`, data)
    return factory.build(request)
  },

  async autorizaSolicitacao(solicitacaoId: string, acao: SolicitacaoAcoesBackofficeEnum, bodyRequest: BodyRequest) {
    const request = await api.put(`solicitacoes-backoffice/${solicitacaoId}/autorizacao/${acao}`, bodyRequest)
    return factory.build(request)
  },

  async solicitaCancelamentoSolicitacao(solicitacaoId: string, motivo: string) {
    const request = await api.put(`solicitacoes-backoffice/${solicitacaoId}/solicita-cancelamento?motivo=${motivo}`, '')
    return factory.build(request)
  },

  async putNovaDataSolicitacao(solicitacaoId: string, novaDataSolicitada: any) {
    const request = await api.put(`solicitacoes-backoffice/${solicitacaoId}/DataAgendamento`, novaDataSolicitada)
    return factory.build(request)
  },

  async backofficeVoltaStatus(params: any) {
    const response = await api.put(`solicitacoes-backoffice/${params.solicitacaoId}/volta-status`, params)
    return factory.build(response)
  },

  async bloquearAgendamento(solicitacaoId: string) {
    const request = await api.post(`solicitacoes/${solicitacaoId}/bloquear`, '')
    return factory.build(request)
  },

  async cadastrarMedicoBackoffice(cadastrarMedico: CadastroMedicoBackoffice) {
    const request = await api.post('backoffice/cadastrar-medico-backoffice', cadastrarMedico)
    return factory.build(request)
  },

  async postCid(solicitacaoId: string, cid) {
    const request = await api.post(`solicitacoes/${solicitacaoId}/cids`, cid)
    return factory.build(request)
  },

  async getAllCidBySolicitacaoId(id: String) {
    const request = await api.get(`solicitacoes/${id}/cids`)
    return factory.build(request)
  },

  async deleteCid(solicitacaoId: string, cidId: string) {
    const request = await api.delete(`solicitacoes/${solicitacaoId}/cids/${cidId}`)
    return factory.build(request)
  },

  async postEquipamento(solicitacaoId: string, equipamento: Equipamento) {
    const request = await api.post(`solicitacoes/${solicitacaoId}/equipamentos`, equipamento)
    return factory.build(request)
  },

  async getEquipamentos(solicitacaoId: String) {
    const request = await api.get(`solicitacoes/${solicitacaoId}/equipamentos`)
    return factory.build(request)
  },

  async deleteEquipamento(solicitacaoId: string, equipamentoId: string) {
    const request = await api.delete(`solicitacoes/${solicitacaoId}/equipamentos/${equipamentoId}`)
    return factory.build(request)
  },

  async salvarNovoFornecedor(novoFornecedor: NovoFornecedor) {
    const request = await api.post('agendamento/fornecedor', novoFornecedor)
    return factory.build(request)
  },

  async postOpme(solicitacaoId: string, opme: OPME) {
    const request = await api.post(`solicitacoes/${solicitacaoId}/opmes`, opme)
    return factory.build(request)
  },

  async getOpmes(solicitacaoId: String) {
    const request = await api.get(`solicitacoes/${solicitacaoId}/opmes`)
    return factory.build(request)
  },

  async postProcedimento(solicitacaoId: string, procedimento: Procedimento) {
    const request = await api.post(`procedimento/${solicitacaoId}/solicitacao-procedimento`, procedimento)
    return factory.build(request)
  },

  async postReservaHemocomponente(solicitacaoId: string, hemocomponente: Hemocomponente) {
    const request = await api.post(`solicitacoes/${solicitacaoId}/reservaHemocomponentes`, hemocomponente)
    return factory.build(request)
  },

  async getAllReservaHemocomponentes(solicitacaoId: String) {
    const request = await api.get(`solicitacoes/${solicitacaoId}/reservaHemocomponentes`)
    return factory.build(request)
  },

  async criarMapaCirurgico(solicitacoes: any) {
    const response = await api.post('mapa-cirurgico', solicitacoes)
    return factory.build(response)
  },

  async getSolicitacoesMapaCirurgico(data: string) {
    const response = await api.get(`mapa-cirurgico?data=${data}`)
    return factory.build(response)
  },

  async getModeloCirurgia(hospitalId: string) {
    const request = await api.get(`hospitais/${hospitalId}/modelo-cirurgia`)
    return factory.build(request)
  },

  async criarModeloCirurgia(params: any) {
    const request = await api.post('modelo-cirurgia', params)
    return factory.build(request)
  },

  async enviarComentario(solicitacaoId: string, comentario: SolicitacaoComentario) {
    const request = await api.post(`solicitacoes/${solicitacaoId}/comentarios`, comentario)
    return factory.build(request)
  },

  async defineLembrete(params: any) {
    const request = await api.put(`solicitacoes/${params.solicitacaoId}/comentarios`, params)
    return factory.build(request)
  },

  async getComentariosBySolicitacaoId(solicitacaoId: string) {
    const request = await api.get(`solicitacoes/${solicitacaoId}/comentarios`)
    return factory.build(request)
  },

  async deleteLaudoById(id: string) {
    const request = await api.delete(`laudos/${id}/delete`)
    return factory.build(request)
  },

  async deleteOpme(solicitacaoId: string, opmeId: string) {
    const request = await api.delete(`solicitacoes/${solicitacaoId}/opmes/${opmeId}`)
    return factory.build(request)
  },

  async deleteProcedimento(solicitacaoId: string, procedimentoId: string) {
    const request = await api.delete(`procedimento/${solicitacaoId}/${procedimentoId}/solicitacao-procedimento`)
    return factory.build(request)
  },

  async deleteProcedimentoPrincipal(solicitacaoId: string) {
    const request = await api.delete(`procedimento/${solicitacaoId}/solicitacao-procedimento-principal`)
    return factory.build(request)
  },

  async deleteReservaHemocomponente(solicitacaoId: string, tipo: string) {
    const request = await api.delete(`solicitacoes/${solicitacaoId}/reservaHemocomponentes/${tipo}`)
    return factory.build(request)
  },

  async desbloquearAgendamento(solicitacaoId: string) {
    const request = await api.post(`solicitacoes/${solicitacaoId}/desbloquear`, '')
    return factory.build(request)
  },

  async deletarEmail(params: any) {
    const response = await api.delete(`agendamento/medico/${params.medicoId}/local-atendimento/${params.localAtendimentoId}/email-notificacao/${params.email}`)
    return factory.build(response)
  },

  async encerrarPendencia(solicitacaoId: string) {
    const request = await api.post(`solicitacoes/${solicitacaoId}/pendencias/encerrar`, {})
    return factory.build(request)
  },

  async postDataAgendamentoMensagem(solicitacaoId: string, mensagem: AlteracaoDataMensagem) {
    const request = await api.post(`solicitacoes/${solicitacaoId}/data-agendamento/chat`, mensagem)
    return factory.build(request)
  },

  async getDataAgendamentoChat(solicitacaoId: string) {
    const request = await api.get(`solicitacoes/${solicitacaoId}/data-agendamento/chat`)
    return factory.build(request)
  },

  async enviarMensagem(solicitacaoId: string, data: any) {
    const request = await api.post(`/solicitacoes/${solicitacaoId}/contestacoes/mensagens/enviar`, data)
    return factory.build(request)
  },

  async enviarMensagemPendencia(solicitacaoId: string, pendencia: Pendencia) {
    const request = await api.post(`solicitacoes/${solicitacaoId}/pendencias/mensagens`, pendencia)
    return factory.build(request)
  },

  async excluirSolicitacaoMapaCirurgico(params: any) {
    const response = await api.put(`mapa-cirurgico/solicitacoes/${params.solicitacaoId}`, { mensagemDaPendencia: params.mensagemDaPendencia })
    return factory.build(response)
  },

  async getCidSearch(hospitalId: string, medicoSolicitanteId: String, searchText: String) {
    const request = await api.get(`/hospitais/${hospitalId}/medico-solicitante/${medicoSolicitanteId}/cids?searchtext=${searchText}`)
    return factory.build(request)
  },

  async getAllConvenio(hospitalId: String) {
    const request = await api.get(`/hospitais/${hospitalId}/convenios`)
    return factory.build(request)
  },

  async getAllPlanos(hospitalId: String, convenioId: String) {
    const request = await api.get(`/hospitais/${hospitalId}/convenios/${convenioId}/planos`)
    return factory.build(request)
  },

  async getAllConveniosByUsuarioHospitalLogado() {
    const request = await api.get('/usuario-hospital/convenios')
    return factory.build(request)
  },

  async getEquipamentoSearch(hospitalId: String, searchText: String) {
    const request = await api.get(`hospitais/${hospitalId}/equipamentos?searchText=${searchText}`)
    return factory.build(request)
  },

  async getAllFornecedor(hospitalId: String, convenioId: String, medicoId: string, solicitacaoId: string) {
    const request = await api.get(`fornecedores?HospitalId=${hospitalId}&convenioId=${convenioId}&medicoId=${medicoId}&solicitacaoId=${solicitacaoId}`)
    return factory.build(request)
  },

  async getHospitalCurrentUser() {
    const request = await api.get('/usuario-hospital/current/hospitais')
    return factory.build(request)
  },

  async getAllLaudos(solicitacaoId: String, tipoDocumento: TipoDocumentoUpload) {
    const request = await api.get(`solicitacoes/${solicitacaoId}/documentos/${tipoDocumento}`)
    return factory.build(request)
  },

  async getMensagemAberta(solicitacaoId: string) {
    const request = await api.get(`solicitacoes/${solicitacaoId}/pendencias/aberta`)
    return factory.build(request)
  },

  async getDocumentosObrigatoriosParaSolicitacao(procedimentos: string[], hospitalId: string, convenioId: string) {
    const params = toHttpParams({ procedimentos, hospitalId, convenioId })
    const request = await api.get(`grupo-documentos-obrigatorios/solicitacao?${params}`)
    return factory.build<IDocumentoObrigatorio[]>(request)
  },

  async getComorbidadesByHospitalId(hospitalId: string) {
    const request = await api.get(`hospitais/${hospitalId}/comorbidades`)
    return factory.build(request)
  },

  async upsertComorbidade(comorbidadePayload: ComorbidadePayloadProps) {
    const request = await api.put('hospitais/comorbidades', comorbidadePayload)
    return factory.build(request)
  },

  async getEstratificacaoById(apaId: string) {
    const request = await api.get(`estratificacao-by-id/${apaId}`)
    return factory.build(request)
  },

  async postIniciaApa(solicitacaoId: string, payload: IniciaApa) {
    const request = await api.post(`solicitacoes/${solicitacaoId}/inicia-apa`, payload)
    return factory.build(request)
  },

}
